import type { PageContext } from '@zto/zpage'

import { commonOptions, DialogType, EnableStatus } from '@/config'

import { addEditDialog } from './_dialogs'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/device/cell-template/pageList'
      },
      add: {
        api: '/sys/admin/device/cell-template/save',
        dialog: addEditDialog(DialogType.ADD)
      },
      detail: {
        dialog: addEditDialog(DialogType.VIEW)
      },
      enable: {
        api: '/sys/admin/device/cell-template/changeStatus',
        payload: { templateCode: '${data.row.templateCode}', status: EnableStatus.ENABLE }
      },
      disable: {
        api: '/sys/admin/device/cell-template/changeStatus',
        payload: { templateCode: '${data.row.templateCode}', status: EnableStatus.DISABLE }
      },
      export: {}
    },
    search: {
      hidden: true
    },
    toolbar: {
      items: [{ action: 'add', label: '新增' }]
    },
    table: {
      editable: true,
      innerAttrs: { rowKey: 'templateCode' },
      operation: {
        width: 120,
        items: [
          { action: 'detail', label: '查看' },
          { action: 'enable', visibleOn: `this.data.row.status !== ${EnableStatus.ENABLE}` },
          { action: 'disable', visibleOn: `this.data.row.status !== ${EnableStatus.DISABLE}` }
        ]
      },
      columns: [
        { label: '模板编号', prop: 'templateCode', width: 160 },
        { label: '模板名称', prop: 'templateName', minWidth: 120 },
        { label: '层数', prop: 'layers', width: 120 },
        { label: '格口总数', prop: 'totalSlots', width: 120 },
        {
          label: '状态',
          prop: 'status',
          formatter: { name: 'enumStr', options: commonOptions.enableStatus },
          width: 120
        }
      ]
    }
  }
}
